import { useFormContext } from 'framework/form';
import { useShowContext } from 'framework/show/ShowContext';

const useContextHelper = () => {
  const { data: formData } = useFormContext();
  const { data: showData } = useShowContext();

  return {
    getFromAnyContext: (source: Nullable<string>) => {
      return (formData && formData[source!]) || (showData && showData.getValueBySource(source));
    },
  };
};

export default useContextHelper;
